module.exports = __webpack_public_path__ + "img/qacard3.58953549.png";